/**
 * Section heading styled like a cassette label header:
 *   - big Antonio uppercase title with cassette letter-spacing
 *   - small kana caption to the right
 *   - thin colored underline (per-section accent)
 */
type Props = {
  children: React.ReactNode;
  /** Small Japanese (or any) caption rendered alongside the title. */
  kana?: string;
  /** Tailwind color class for the underline + kana, e.g. "text-accent-coral". */
  accent?: string;
};

const SectionHeading = ({ children, kana, accent = 'text-accent-oxblood' }: Props) => {
  const borderColor = accent.replace('text-', 'border-');
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <h2 className="font-display text-5xl md:text-6xl font-bold uppercase leading-none tracking-retro text-ink">
        {children}
      </h2>
      {kana ? (
        <span className={`font-kana text-base font-bold tracking-wider ${accent}`}>{kana}</span>
      ) : null}
      <span aria-hidden className={`block w-full border-b-[3px] ${borderColor}`} />
    </div>
  );
};

export default SectionHeading;
